import * as Yup from "yup";

export const SaveAsValidationSchema = (initialNameValue: string) => {
  return Yup.object<any>().shape({
    templateName: Yup.string()
      .nullable()
      .notOneOf(
        [initialNameValue],
        "US.USC.TEMPLATEEDITOR:VALIDATIONS.PLEASE_PROVIDE_ALTERNATIVE_TEMPLATE_NAME"
      )
      .required("US.USC.TEMPLATEEDITOR:VALIDATIONS.TEMPLATE_NAME_IS_REQUIRED"),
    mainAdapterId: Yup.number()
      .nullable()
      .required("US.USC.TEMPLATEEDITOR:VALIDATIONS.MAIN_ADAPTER_IS_REQUIRED"),
  });
};
